import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Contenu } from './Contenu'; export { Contenu }
import * as tools from '../Tools'

// import RoomIcon from '@material-ui/icons/Room';
// import PhoneIcon from '@material-ui/icons/Phone';
// import EmailIcon from '@material-ui/icons/Email';

// import {
// 	mobile,
// 	grandEcranBlocTexteDroit,
// 	grandEcranBlocTexteGauche
// } from './Commun';

export class ModuleBlocGaucheDroite extends React.Component {
	mobile = data => {
		return (
			<Fragment>
				{/* *** icone carte *** */}
				<div className="" style={{ margin: '0 auto', width: '100px' }}>
					<img
						// src={require(`../../resources/icons/${data.iconSrc}`)}
						src={data.iconSrc}
						className="img-fluid"
						style={{}}
					/>
				</div>
				{/* **************** */}
				{/* *** Titre gris *** */}
				{/* <div
					className="ft-parisienne text-center"
					style={{
						fontSize: '300%',
						color: 'rgb(173, 173, 172)'
					}}
				>
					{data.titreGris}
				</div> */}
				{/* ****** */}

				<h1 className="contenu-h1 pt-3">{data.titre}</h1>

				{/* *** photo *** */}
				<div className="text-center pt-3">
					<img
						// src={require(`../../resources/photos/${data.imgSrc}`)}
						src={`${tools.lienPhotos}/${data.imgSrc}`}
						className="img-fluid"
						style={{ maxHeight: '600px' }}
					/>
				</div>
				{/* ************ */}
				<div className="p-3 bg-white">
					{data.contenu && <p className="pt-5">{data.contenu}</p>}
					<div className="pt-5">
						{data.boutons.map(element => {
							return (
								<div className="text-center" style={{ paddingBottom: '70px' }}>
									<Link
										to={element.lien}
										className="text-center mt-5 ft-lato-light p-3 text-uppercase"
										style={{
											fontSize: '1.1em',
											color: '#333',
											border: '1px solid #000'
										}}
									>
										{element.nom}
									</Link>
								</div>
							);
						})}
					</div>
				</div>
			</Fragment>
		);
	};

	grandEcranBlocTexteGauche = data => {
		return (
			<Fragment>
				<div
					className="mt-5 mb-5"
					style={{
						paddingTop: '40px',
						display: 'flex',
						paddingLeft: '4%',
						paddingRight: '10%',
						marginBottom: '50%'
					}}
				>
					<div style={{ maringTop: '0px', flex: '0.3' }}>
						<img
							className=""
							style={{ width: '200px', height: '200px' }}
							// src={require(`../../resources/icons/${data.iconSrc}`)}
							src={data.iconSrc}
						></img>
					</div>
					<div style={{ flex: '0.4', zIndex: '2' }}>
						<span
							className="ft-parisienne text-center"
							style={{
								fontSize: '300%',
								color: '#666'
							}}
						>
							{data.titreGris}
						</span>
						<Contenu data={data} />
					</div>

					<div
						style={{
							width: 500,
							height: 400,
							flex: '0.9',
							position: 'relative',
							zIndex: '1'
						}}
					>
						<img
							// src={require(`../../resources/photos/${data.imgSrc}`)}
							src={`${tools.lienPhotos}/${data.imgSrc}`}
							className="img-fluid"
							style={{ maxWidth: '900px' }}
						/>
					</div>
				</div>
			</Fragment>
		);
	};

	grandEcranBlocTexteDroit = data => {
		return (
			<Fragment>
				<div
					className="mt-5 mb-5"
					style={{
						paddingTop: '40px',
						display: 'flex',
						paddingLeft: '10%',
						paddingRight: '4%',
						paddingBottom: '150px'
					}}
				>
					<div
						style={{
							width: '400px',
							// height: '400px',
							flex: '0.9',
							position: 'relative',
							zIndex: '1'
						}}
					>
						<span
							className="ft-parisienne text-center"
							style={{
								fontSize: '300%',
								color: '#666'
							}}
						>
							{data.titreGris}
						</span>
						<img
							// src={require(`../../resources/photos/${data.imgSrc}`)}
							src={`${tools.lienPhotos}/${data.imgSrc}`}
							// className="img-fluid"
							style={{ maxWidth: '900px' }}
						/>
					</div>

					<div style={{ flex: '0.4', zIndex: '2', position: 'relative' }}>
						<Contenu data={data} />
					</div>

					<div style={{ flex: '0.3', paddingLeft: '6%' }}>
						<img
							className=""
							style={{ width: '200px', height: '200px', marginTop: '-100px' }}
							// src={require(`../../resources/icons/${data.iconSrc}`)}
							src={data.iconSrc}
						></img>
					</div>
				</div>
			</Fragment>
		);
	};

	render() {
		const data = this.props.data;
		const { t } = this.props;

		return (
			<div className="">
				<div className="d-none d-xl-block">
					{this.props.data.textPosition === 'droite' &&
						this.grandEcranBlocTexteDroit(data)}
					{this.props.data.textPosition === 'gauche' &&
						this.grandEcranBlocTexteGauche(data)}
				</div>
				<div className="d-block d-xl-none pt-4">{this.mobile(data)}</div>
			</div>
		);
	}
}